/**
 * Copyright © Veeam Software Group GmbH.
 */

import { EVacAgentStatusInteg } from '@veeam-vspc/models/web-controllers';

export type EAgentCommonStatuses = EVacAgentStatusInteg;
export const EAgentCommonStatuses = EVacAgentStatusInteg;
